import { useQuery } from '@tanstack/react-query';
import { API_AGGREGATOR_GET_DISCLOSURES } from 'src/api/aggregator-request-objects';
import { TsQueryI } from 'src/api/query-logic/query-interfaces';
import { createQueryKey } from 'src/api/query-logic/query-utils';
import { apiRequest } from 'src/api/request-handler';
import { AggregatorDisclosure } from 'src/interfaces/aggregator.interfaces';

export const queryAggregatorDisclosures = (obj: TsQueryI) => {
  return useQuery<AggregatorDisclosure[]>({
    queryKey: createQueryKey('aggregator-disclosures', obj.queryKey),
    queryFn: async () => {
      const res = await apiRequest<AggregatorDisclosure[]>(API_AGGREGATOR_GET_DISCLOSURES, obj.reqData);
      return res;
    },
    staleTime: 5 * 60 * 1000,
    ...obj.queryOpt,
    refetchOnWindowFocus: false,
  });
};
